<template>
	<div id="progress-circle" >  
        <svg :height="circleSize" :width="circleSize">
            <!-- <g> -->
                <circle :cx="circleSize / 2" :cy="circleSize / 2" :r="radius" :stroke-width="strokeWidth" :style="cssProps" > </circle>
                <circle :cx="circleSize / 2" :cy="circleSize / 2" :r="radius" :stroke-width="strokeWidth" :class="{ noshow: show }" :style="[cssProps, {strokeDashoffset:barFill}]"> </circle>
            <!-- </g> -->
        </svg>
        <h3 class="number" :style="cssProps" >   
            <animate-text :number="percentage" :animateTime="50"/> 
            <span class="percentage">%</span>
        </h3>
	</div>
</template>
<script>
    import AnimateText from '@/components/AnimateText.vue'
	export default {
        props:{
            maxAmount: Number,
            activeAmount: Number,
            totalAmount: Number,
            showVariableInfo: Boolean,
            circleSize: {
                type: Number,
                defualt: 120
            },
            strokeWidth: {
                type: Number,
                default: 6
            },
            textSize: {
                type: Number,
                default: 28
            }
        },  
	data(){
		return{
            percentage: this.activeAmount / this.maxAmount * 100,
            show: true,
            // circumference: null
        }		
    },
    computed:{
        cssProps(){
          return { '--circumference' : (this.circumference), '--text-size' : this.textSize + "px"}
        },
        circumference(){
            return (2 * Math.PI * this.radius).toFixed(0)
        },
        radius(){
            return (this.circleSize / 100) * 45
        },
        barFill(){
            if(this.percentage > 100) return this.circumference - (this.circumference * 100) / 100
            else return this.circumference - (this.circumference * this.percentage) / 100
        },

   
    },
     mounted(){
        // this.percentage = Math.round(this.percentage * 10) / 10
        this.percentage = Math.round(this.percentage)
        // this.circumference =  (2 * Math.PI * this.radius)
    },

    created(){
        setTimeout(() => {
            this.show = false
        }, 100);
    },
        components:{
            AnimateText
        }
    }
</script>

<style lang="less">
#progress-circle{
    position: relative;
    display: flex;
    justify-content: center;
        svg{
            circle{
                fill: none;
                stroke-dasharray: var(--circumference);
                stroke-dashoffset: var(--circumference);
                transform: rotate(-90deg);
                transform-origin: center;

                &:nth-child(1){
                    stroke-dashoffset: 0;
                    stroke: rgba(143, 151, 156, 0.192);
                }
                &:nth-child(2){
                    stroke-dashoffset: calc(var(--circumference) - (var(--circumference) * 0 ) /100);
                    stroke: var(--orange-web);
                    stroke-linecap: round;
                    transition: .5s;
                }
            }
        }

       .number{
            cursor: default;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: var(--text-size);
            display: flex;
        }
    .noshow{   
        stroke-dashoffset: calc(var(--circumference) - (var(--circumference) * 0) /100) !important;
    }
}
    
</style>
